module.exports = __webpack_public_path__ + "img/Viviana.2a2cf65e.jpg";